// 未配置保留旧入口；显式关闭或绑定不可见活动不回退其它签到。
export function personalSignInActivity(items, binding) {
 if (!Array.isArray(items)) throw new Error('签到活动查询失败');
 if (!binding || typeof binding.configured !== 'boolean') throw new Error('签到展示配置不完整');
 const eligible = items.filter(item => item.activityType === 'SIGN_IN' && Number(item.status) === 1);
 if (!binding.configured) return eligible[0] || null;
 if (typeof binding.enabled !== 'boolean') throw new Error('签到展示配置不完整');
 if (!binding.enabled) return null;
 if (!Number.isSafeInteger(binding.activityId) || binding.activityId <= 0 || ![0, 1, 2].includes(binding.signCategory) || typeof binding.activityTitle !== 'string') throw new Error('签到绑定信息不完整');
 const item = eligible.find(row => String(row.id) === String(binding.activityId));
 return item ? { ...item, signCategory: binding.signCategory, signDisplayTitle: binding.activityTitle } : null;
}
